import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { ApolloProvider } from '@trello/graphql';
import { useLazyComponent } from '@trello/use-lazy-component';

export const dialogProps = {
  displayType: 'workspace-invite-modal',
};

export const LazyWorkspaceInviteModal: FunctionComponent<{
  workspaceId: string;
  onClose: () => void;
}> = ({ workspaceId, onClose }) => {
  const WorkspaceInviteModal = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "workspace-invite-modal" */ './WorkspaceInviteModal'
      ),
    {
      preload: false,
      namedImport: 'WorkspaceInviteModal',
    },
  );

  return (
    <Suspense fallback={null}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-web-eng',
          feature: 'Workspace Invite Modal',
        }}
      >
        <ChunkLoadErrorBoundary fallback={null}>
          <ApolloProvider>
            <WorkspaceInviteModal workspaceId={workspaceId} onClose={onClose} />
          </ApolloProvider>
        </ChunkLoadErrorBoundary>
      </ErrorBoundary>
    </Suspense>
  );
};
